import { mixpanel } from '@fiverr-private/obs';
import { getDataFromStores } from '../../../utils';
import { MIXPANEL_EVENT_PROPERTIES, ACTION_NAMES, MIXPANEL_GENERIC_EVENTS } from '../../constants';
import { Enrichment } from '../types';
import { BlogArticleClickedInput, BlogArticleClickedStore } from './types';
/**
 * The user clicked on the blog article.
 */
export const createReportBlogArticleClicked =
    (store: BlogArticleClickedStore, enrichment?: Enrichment) =>
    ({ title, horizontalPosition }: BlogArticleClickedInput): void => {
        const { ARTICLE_TITLE, HORIZONTAL_POSITION, ACTION } = MIXPANEL_EVENT_PROPERTIES;

        const customPayload = {
            [ARTICLE_TITLE]: title,
            [HORIZONTAL_POSITION]: horizontalPosition,
            [ACTION]: ACTION_NAMES.CLICKED_ARTICLE,
            ...enrichment,
        };

        const payload = {
            ...getDataFromStores(store.user, store.referrer, store.fromBoost, store.pageType, store.pagePath),
            ...customPayload,
        };

        mixpanel.track(MIXPANEL_GENERIC_EVENTS.PAGE_ACTION, payload);
    };
